import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function SpeedRow() {
   return (
      <InputRangeRow
         titleProp={"Speed"}
         descriptionProp={"rpm"}
         sizeProp={4}
         typeProp={"text"}
         minProp={500}
         maxProp={1995}
         propertyNameProp={"speed"}
         errorDialogueProp={"500-1,995 only"}
         floatProp={false}
      />
   );
}
